/* tslint:disable */
/* eslint-disable */
/**
 * API SPECS
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CheckupData } from './CheckupData';
import {
    CheckupDataFromJSON,
    CheckupDataFromJSONTyped,
    CheckupDataToJSON,
} from './CheckupData';
import type { PaginationInfo } from './PaginationInfo';
import {
    PaginationInfoFromJSON,
    PaginationInfoFromJSONTyped,
    PaginationInfoToJSON,
} from './PaginationInfo';

/**
 * 
 * @export
 * @interface CheckupDataPagination
 */
export interface CheckupDataPagination {
    /**
     * 
     * @type {Array<CheckupData>}
     * @memberof CheckupDataPagination
     */
    data?: Array<CheckupData>;
    /**
     * 
     * @type {PaginationInfo}
     * @memberof CheckupDataPagination
     */
    meta?: PaginationInfo;
}

/**
 * Check if a given object implements the CheckupDataPagination interface.
 */
export function instanceOfCheckupDataPagination(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CheckupDataPaginationFromJSON(json: any): CheckupDataPagination {
    return CheckupDataPaginationFromJSONTyped(json, false);
}

export function CheckupDataPaginationFromJSONTyped(json: any, ignoreDiscriminator: boolean): CheckupDataPagination {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(CheckupDataFromJSON)),
        'meta': !exists(json, 'meta') ? undefined : PaginationInfoFromJSON(json['meta']),
    };
}

export function CheckupDataPaginationToJSON(value?: CheckupDataPagination | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(CheckupDataToJSON)),
        'meta': PaginationInfoToJSON(value.meta),
    };
}

